import React, { useEffect, useState } from 'react';
import { ChevronDown, Zap, Code, Layers, Cpu } from 'lucide-react';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand/10 via-transparent to-brand-light/10"></div>
      <div className="absolute top-20 left-10 w-72 h-72 bg-brand/20 rounded-full blur-3xl animate-pulse-slow"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-brand-light/20 rounded-full blur-3xl animate-pulse-slow animation-delay-400"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-highlight/10 rounded-full blur-3xl animate-pulse-slow animation-delay-600"></div>

      {/* Floating Icons */}
      <div className="absolute top-32 right-20 animate-hover">
        <Code className="w-8 h-8 text-brand/30" />
      </div>
      <div className="absolute bottom-32 left-20 animate-hover animation-delay-200">
        <Layers className="w-8 h-8 text-brand-light/30" />
      </div>
      <div className="absolute top-1/2 right-32 animate-hover animation-delay-400">
        <Cpu className="w-8 h-8 text-highlight/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto content-padding text-center">
        <div className={`space-y-8 ${isVisible ? 'fade-in-up' : 'opacity-0'}`}>
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-dark-surface/50 border border-dark-border rounded-full">
            <Zap className="w-4 h-4 text-brand" />
            <span className="text-sm text-dark-muted">Intelligence meets Innovation</span>
          </div>

          {/* Headline */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold">
            <span className="block mb-2">Elevating Ideas Into</span>
            <span className="brand-gradient">Intelligent Solutions</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-dark-muted max-w-3xl mx-auto leading-relaxed">
            We engineer next-generation software solutions that accelerate business growth, transform user experiences, 
            and empower organizations to thrive in the digital era.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <button 
              onClick={scrollToServices}
              className="action-btn group flex items-center gap-2"
            >
              Explore Our Services
              <ChevronDown className="w-4 h-4 group-hover:translate-y-1 transition-transform" />
            </button>
            <button 
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="outline-btn"
            >
              Get in Touch
            </button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 pt-12 max-w-2xl mx-auto">
            <div className="text-center">
              <div className="text-3xl font-bold brand-gradient">500+</div>
              <div className="text-sm text-dark-muted mt-1">Projects Delivered</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold brand-gradient">99%</div>
              <div className="text-sm text-dark-muted mt-1">Client Satisfaction</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold brand-gradient">24/7</div>
              <div className="text-sm text-dark-muted mt-1">Support Available</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="w-6 h-6 text-dark-muted" />
      </div>
    </section>
  );
};

export default Hero;

